




































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { MapStoreModule } from "@/store/modules/mapStore";
import ZipcodeInput from "@/components/ZipcodeInput.vue";
import { formatSize } from "@/utils/helpers.ts";
import {decode} from 'html-entities';

@Component({
  components: {
    ZipcodeInput
  }
})
export default class StoreList extends Vue {
    @Prop() configs!: any;

  get isProjectCategoryName(): boolean {
    if (!this.configs['map-project-category-name'] || this.configs['map-project-category-name'] == '') {
      return false
    }
    return true
  }

  get isProjectName(): boolean {
    if (!this.configs['map-project-name'] || this.configs['map-project-name'] == '') {
      return false
    }
    return true
  }

  get isProjectType(): boolean {
    if (!this.configs['map-project-type'] || this.configs['map-project-type'] == '') {
      return false
    }
    return true
  }

  get isProjectPhone(): boolean {
    if (!this.configs['map-project-phone'] || this.configs['map-project-phone'] == '') {
      return false
    }
    return true
  }

  get isProjectSize(): boolean {
    if (!this.configs['map-project-size'] || this.configs['map-project-size'] == '') {
      return false
    }
    return true
  }

  get isProjectStreet(): boolean {
    if (!this.configs['map-project-street'] || this.configs['map-project-street'] == '') {
      return false
    }
    return true
  }
  get isProjectCity(): boolean {
    if (!this.configs['map-project-city'] || this.configs['map-project-city'] == '') {
      return false
    }
    return true
  }

  get isProjectState(): boolean {
    if (!this.configs['map-project-state'] || this.configs['map-project-state'] == '') {
      return false
    }
    return true
  }

  get isProjectZipcode(): boolean {
    if (!this.configs['map-project-zipcode'] || this.configs['map-project-zipcode'] == '') {
      return false
    }
    return true
  }

    get isDataRequest(): boolean {
    return MapStoreModule.isRequest;
  }

  get existStores(): boolean {
    return MapStoreModule.isActiveStatus;
  }

  get availableStores() {
    return MapStoreModule.stores;
  }

  private escapeHtml(text: string): string {
    return decode(text, {level: 'html5'})
  }

  private setSize(elem: any): string {
    let price = "";

    if (elem.additionFields) {
      price = elem.additionFields.project_size ? elem.additionFields.project_size : "0";
      return formatSize(price);
    }
    price = elem.project_size ? elem.project_size : "0";
    return formatSize(price);
  }

  private setActiveMark(id: number): void {
    const myElement = document.getElementById("list-" + id);
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const topPos = myElement.offsetTop;
    setTimeout(() => {
      document
        .getElementsByClassName("distrib-view")[0]
        .scrollTo({ top: topPos - 130, behavior: "smooth" });
      MapStoreModule.changeStore(id);
      MapStoreModule.togglePopUp(false);
    }, 100);
  }
}
